import React from 'react';
import './Hero.css';
import Nav from '../inc/Nav/Nav';

type Props = {
  img: string;
  title: string;
  subtitle?: string;
};

const Hero: React.FC<Props> = ({
  img,
  title,
  subtitle,
}) => {
  return (
    <header className="hero-hero" role="banner">
      {/* Background image */}
      <img src={img} alt="Hero" className="hero-video" />
      <Nav />

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content container">
        <div className="hero-text">
          <h1 className="hero-title slide-in-left">
            {title}
          </h1>

          {subtitle && (
            <h4 className="hero-subtitle slide-in-left-delayed">
              {subtitle}
            </h4>
          )}

          <div className="hero-cta">
            <a href="#contact" className="button-hero-cta">
              Get a Custom Quote
            </a>
          </div>
        </div>
        <div className="hero-shape" aria-hidden></div>
      </div>
    </header>
  );
};

export default Hero;